<template>
  <el-checkbox
    v-model="checkboxValue"
    :true-label="trueLabel"
    :false-label="falseLabel"
    :disabled="disabled"
    :data-qa="dataQa"
  >
    <div class="content-ct">
      <div v-if="icon" class="icon-ct">
        <icon :glyph="icon" />
      </div>
      <div class="label">
        <div class="title" v-if="title">
          {{ title }}
          <span class="changed-dot" v-if="isChanged"></span>
        </div>
        <div class="description" v-if="description">{{ description }}</div>
      </div>
    </div>
  </el-checkbox>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    },
    value: {
      required: true
    },
    label: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    trueLabel: {
      type: [String, Number],
      default: 1
    },
    falseLabel: {
      type: [String, Number],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isChanged: {
      type: Boolean,
      default: false,
      required: false
    },
    dataQa: {
      type: String,
      required: false
    }
  },
  computed: {
    checkboxValue: {
      get() {
        return this.value
      },

      set(checkboxValue) {
        this.$emit('input', checkboxValue)
      }
    }
  }
}
</script>

<style scoped>
.el-checkbox {
  display: flex;
  border-color: #dbdee7;
  box-sizing: border-box;
  padding: 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
>>> .el-checkbox__input {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 0;
  -ms-flex: 0;
  flex: 0;
}
>>> .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #1d87c8 !important;
  background-color: #1d87c8;
}
>>> .el-checkbox__inner {
  border-color: #dcdfe6 !important;
  background-color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
>>> .el-checkbox__inner::after {
  height: 8px;
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;
  top: 3px;
  left: 6px;
  width: 4px;
}
.content-ct {
  display: flex;
}
.icon-ct {
  padding-right: 10px;
  font-size: 20px;
  color: #5c6374;
}
.title {
  color: #5c6374;
}

.description {
  color: #7e8596;
  font-size: 12px;
}
.changed-dot {
  height: 5px;
  width: 5px;
  background-color: #c81d87;
  border-radius: 50%;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/Checkbox.vue